import Layout from '@/components/layout/index.vue'
export default {
  path: 'myappointment',
  name: 'Myappointment',
  meta: {},
  component: Layout,
  redirect: { name: 'Myappointment.Myappointment' },
  children: [
    {
      path: 'myappointment',
      name: 'Myappointment.Myappointment',
      meta: {},
      component: () => import(/* webpackChunkName: "myappointment" */ '@/views/supplier/myappointment/myappointment/index')
    },
    {
      path: 'myappointment/add',
      name: 'Myappointment.Myappointment.Add',
      meta: { title: 'common.add', dep: 'Myappointment.Myappointment' },
      component: () => import(/* webpackChunkName: "myappointment" */ '@/views/supplier/myappointment/myappointment/add.vue')
    },
    {
      path: 'myappointment/perfect/:appointUuid',
      name: 'Myappointment.Myappointment.Perfect',
      meta: { title: 'deliveryappointment.urgentreservation.perfect', dep: 'Myappointment.Myappointment' },
      component: () => import(/* webpackChunkName: "myappointment" */ '@/views/supplier/myappointment/myappointment/perfect.vue')
    }
  ]
}
